import apiClient from "@/services/apiClient.js";

export async function SearchByNumber(number)
{
    const resp = await apiClient.get(`api/GetAccountData/${number}`);

    return resp.data;
}